import IconClose, { IconCloseProps as _IconCloseProps } from './IconClose';

export { IconClose };
export type IconCloseProps = _IconCloseProps;
